define('setup/configurators/configurator',[],function () {
    // interface that all configurators must implement
    return {
        setCompleteUrl: function () {},
        get: function () {}
    };
});

